import { HttpMethod } from "../../common/constants/http-requests";
import { httpRequest } from "../../common/utils/http-request";
import { TASK_API, PROJECT_MANAGEMENT_API } from "../api";

export const getMyAssignedTasks = () =>
    httpRequest({
        url: `${TASK_API}/my-assigned-tasks`,
        method: HttpMethod.GET,
    });

export const updateTaskStatus = (taskId, statusData) => {
    return httpRequest({
        url: `${TASK_API}/${taskId}/status`,
        method: HttpMethod.PUT,
        data: statusData,
    });
};

export const createTask = (taskData) => {
    return httpRequest({
        url: `${TASK_API}/create-task`,
        method: HttpMethod.POST,
        data: taskData,
    });
};

// Get all tasks for a specific employee by their Azure ID (UUID)
export const getEmployeeTasks = (assigneeAzureId) => {
    return httpRequest({
        url: `${TASK_API}/user/${assigneeAzureId}`,
        method: HttpMethod.GET,
    });
};

// Get all tasks for a specific project allocation ID
export const getTasksByProjectAllocation = (projectAllocationId) => {
    return httpRequest({
        url: `${TASK_API}/allocation/${projectAllocationId}`,
        method: HttpMethod.GET,
    });
};

// Get messages for a specific task
export const getTaskMessages = (taskId) => {
    return httpRequest({
        url: `${TASK_API}/${taskId}/messages`,
        method: HttpMethod.GET,
    });
};

// Add a message to a specific task
export const addTaskMessage = (taskId, messageData) => {
    return httpRequest({
        url: `${TASK_API}/${taskId}/messages`,
        method: HttpMethod.POST,
        data: messageData,
    });
};

// =====================================================
// HYBRID WORKFLOW BATCH APIs for Efficient Performance
// =====================================================

// PART A: Batch APIs for Initial Page Load (Efficient Task Count Display)

// Step 1: Get allocation IDs for multiple employees in one batch call
export const getBatchAllocationIds = (employeeIds) => {
    return httpRequest({
        url: `${PROJECT_MANAGEMENT_API}/bench-allocation-ids`,
        method: HttpMethod.POST,
        data: { employeeIds },
    });
};

// Step 2: Get active task counts for multiple allocation IDs in one batch call
export const getActiveTaskCountsBatch = (projectAllocationIds) => {
    return httpRequest({
        url: `${TASK_API}/allocations/active-counts`,
        method: HttpMethod.POST,
        data: { projectAllocationIds },
    });
};

// SIMPLIFIED: Get active task counts directly for employee IDs (no allocation ID mapping needed)
export const getActiveTaskCountsByEmployeeIds = (employeeIds) => {
    return httpRequest({
        url: `${TASK_API}/allocations/active-counts`,
        method: HttpMethod.POST,
        data: { employeeIds }, // Pass employee IDs directly
    });
};